document.addEventListener("DOMContentLoaded", () => {
  const isMobile = () => window.matchMedia("(max-width: 989px)").matches;

  const megaMenus = document.querySelectorAll("header-menu .mega-menu");

  megaMenus.forEach((menu) => {
    const trigger = menu.querySelector(".header__menu-item");
    const dropdown = menu.querySelector(".mega-menu__content");
    const dropdown_wrapper = menu.querySelector(".mega-menu__content > .mega-menu__content-wrapper");
    

    if (!trigger || !dropdown) return;

    /* -----------------------------
        DESKTOP BEHAVIOR: HOVER
    ------------------------------*/
    menu.addEventListener("mouseenter", () => {
      if (!isMobile()) {
        dropdown.classList.add("menu-open");
        dropdown_wrapper.style.display = "block";

      }
    });

    menu.addEventListener("mouseleave", () => {
      if (!isMobile()) {
        dropdown.classList.remove("menu-open");
         dropdown_wrapper.style.display = "none";
      }
    });


    /* -----------------------------
        MOBILE: CLICK TO OPEN
    ------------------------------*/
    trigger.addEventListener("click", () => {
      if (isMobile()) {
        dropdown.style.display =
          dropdown.style.display === "block" ? "none" : "block";
      }
    });
  });
});


class RHSlider extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector(".slider-track");
    this.btnPrev = this.querySelector(".slider-prev");
    this.btnNext = this.querySelector(".slider-next");

    this.isInfinite = this.dataset.infinite === "true";
    this.isAnimating = false;
    this.position = 0;
    this._eventsBound = false;
  }

  init() {
    if (!this.track) return;

    /* ----------------------------------------------
       1️⃣ Remove all clones (clean reset)
    ----------------------------------------------- */
    this.track.querySelectorAll(".clone").forEach((c) => c.remove());

    /* ----------------------------------------------
       2️⃣ Recalculate REAL slides (NO clones)
    ----------------------------------------------- */
    this.slides = Array.from(this.querySelectorAll(".slide:not(.clone)"));
    if (this.slides.length === 0) return;

    this.slideWidth = this.slides[0].offsetWidth;

    // slides visible at once
    this.visibleCount = Math.floor(this.clientWidth / this.slideWidth) || 1;

    // swiper-style cloneCount
    this.cloneCount = Math.min(this.visibleCount, this.slides.length);

    /* ----------------------------------------------
       3️⃣ Build Swiper-style clones on each side
    ----------------------------------------------- */
    if (this.isInfinite) {
      this.buildClones();
    }

    /* ----------------------------------------------
       4️⃣ Rebuild full slide list
    ----------------------------------------------- */
    this.allSlides = Array.from(this.track.children);

    if (!this._eventsBound) {
      this.bindEvents();
      this._eventsBound = true;
    }

    /* ----------------------------------------------
       5️⃣ Position inside clone buffer
    ----------------------------------------------- */
    if (this.isInfinite) {
      this.position = this.cloneCount * this.slideWidth;
      this.jumpTo(this.position);
    }
  }

  /* ----------------------------------------------
     Build clones (Swiper-style)
     Clone ONLY visibleCount slides left + right
  ----------------------------------------------- */
  buildClones() {
    const leftFrag = document.createDocumentFragment();
    const rightFrag = document.createDocumentFragment();

    const total = this.slides.length;

    // Clone last N slides → left side
    for (let i = total - this.cloneCount; i < total; i++) {
      let clone = this.slides[i].cloneNode(true);
      clone.classList.add("clone");
      leftFrag.appendChild(clone);
    }

    // Clone first N slides → right side
    for (let i = 0; i < this.cloneCount; i++) {
      let clone = this.slides[i].cloneNode(true);
      clone.classList.add("clone");
      rightFrag.appendChild(clone);
    }

    this.track.prepend(leftFrag);
    this.track.append(rightFrag);
  }

  /* ---------------------------------------------- */
  bindEvents() {
    this.btnNext?.addEventListener("click", () => this.move(1));
    this.btnPrev?.addEventListener("click", () => this.move(-1));

    window.addEventListener("resize", () => this.init());
    this.addSwipeHandlers();
  }

  addSwipeHandlers() {
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.touching = false;

    this.track.addEventListener(
      "touchstart",
      (e) => {
        this.touchStartX = e.touches[0].clientX;
        this.touchEndX = this.touchStartX;
        this.touching = true;
      },
      { passive: true }
    );

    this.track.addEventListener(
      "touchmove",
      (e) => {
        if (!this.touching) return;
        this.touchEndX = e.touches[0].clientX;
      },
      { passive: true }
    );

    this.track.addEventListener("touchend", () => {
      if (!this.touching) return;
      this.touching = false;

      const delta = this.touchEndX - this.touchStartX;
      const threshold = this.slideWidth * 0.25;

      if (Math.abs(delta) > threshold) {
        delta < 0 ? this.move(1) : this.move(-1);
      }
    });
  }

  move(dir) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const step = this.slideWidth * this.visibleCount;
    this.position += step * dir;

    this.track.style.transition = "transform 0.35s ease";
    this.track.style.transform = `translateX(-${this.position}px)`;

    setTimeout(() => {
      this.correctLoop();
      this.isAnimating = false;
    }, 360);
  }

  correctLoop() {
    const realWidth = this.slides.length * this.slideWidth;
    const fullLoopWidth = (this.slides.length + this.cloneCount * 2) * this.slideWidth;

    // Too far right → wrap inside
    if (this.position >= realWidth + this.cloneCount * this.slideWidth) {
      this.position -= realWidth;
      this.jumpTo(this.position);
    }

    // Too far left → wrap inside
    if (this.position < this.cloneCount * this.slideWidth) {
      this.position += realWidth;
      this.jumpTo(this.position);
    }
  }

  jumpTo(pos) {
    this.track.style.transition = "none";
    this.track.style.transform = `translateX(-${pos}px)`;
    this.track.offsetHeight; // force reflow
    this.track.style.transition = "";
  }
}

/* Register element */
customElements.define("rh-slider", RHSlider);



/* ----------------------------------------------------
   RECENTLY VIEWED 
------------------------------------------------------ */


function renderRecentlyViewed() {
  console.log("RV: DOM Loaded");

  const container = document.querySelector("#recently-viewed-track");
  if (!container) return;

  let items = JSON.parse(localStorage.getItem("recently_viewed") || "[]");

  /* ---- GET CLEAN CURRENT HANDLE ---- */
  let currentHandle = window.location.pathname.split("/products/")[1] || "";
  currentHandle = currentHandle.split("?")[0].split("/")[0];

  /* ---- CLEAN INVALID ITEMS + REMOVE CURRENT PRODUCT ---- */
  items = items.filter((item) => {
    if (!item) return false;
    if (!item.url || !item.title || !item.img) return false;

    // Block liquid leftovers
    if (String(item.url).includes("{")) return false;
    if (String(item.title).includes("{")) return false;
    if (String(item.img).includes("{")) return false;

    // Extract handle from item URL
    let handle = item.url.split("/products/")[1] || "";
    handle = handle.split("?")[0].split("/")[0];

    // Remove ANY entry matching the current product
    // if (handle === currentHandle) return false;

    return true;
  });

  /* ---- REMOVE DUPLICATES BY URL ---- */
  const unique = [];
  const seen = new Set();

  for (const item of items) {
    if (!seen.has(item.url)) {
      seen.add(item.url);
      unique.push(item);
    }
  }
  items = unique;

  /* ---- HIDE SECTION IF EMPTY ---- */
  if (items.length === 0) {
    const wrap = container.closest(".recently-viewed-wrapper");
    if (wrap) wrap.style.display = "none";
    return;
  }


  container.innerHTML = "";


  

  /* ---- RENDER ---- */
  items.forEach((item) => {
    const slide = document.createElement("div");
    slide.classList.add("slide");
    slide.innerHTML = `
      <div class="card-wrapper product-card-wrapper recently-viewed-card">
        <div class="card card--standard card--media" style="--ratio-percent: 100%;">
          <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                <img
                  srcset="
                    ${item.img}&width=165 165w,
                    ${item.img}&width=360 360w,
                    ${item.img}&width=533 533w,
                    ${item.img}&width=720 720w,
                    ${item.img}&width=940 940w,
                    ${item.img} 1000w
                  "
                  src="${item.img}&width=533"
                  sizes="(min-width: 1400px) 317px,
                    (min-width: 990px) calc((100vw - 130px) / 4),
                    (min-width: 750px) calc((100vw - 120px) / 3),
                    calc((100vw - 35px) / 2)"
                  alt="${item.title}"
                  class="motion-reduce"
                  loading="lazy"
                  width="1000"
                  height="1000"
                >
              </div>
            </div>

            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading">
                  <a href="${item.url}" class="full-unstyled-link">
                    ${item.title}
                  </a>
                </h3>
              </div>
              <div class="card__badge bottom left"></div>
            </div>
          </div>

          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h5">
                <a href="${item.url}" class="full-unstyled-link">
                  ${item.title}
                </a>
              </h3>

              <div class="card-information">
                <span class="caption-large light"></span>
                <div class="price">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span class="price-item price-item--regular">${item.price}</span>
                    </div>

                    <div class="price__sale">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span class="price-item price-item--sale price-item--last js-price-sale">
                        ${item.price}
                      </span>
                      <span>
                        <s class="price-item price-item--regular js-price-compare"></s>
                      </span>
                      <span class="visually-hidden visually-hidden--inline">Sale price</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card__badge bottom left"></div>
          </div>
        </div>
      </div>`;
    container.appendChild(slide);
  });

  /* ---- INIT SLIDER ---- */
function initRecentlySlider(items) {
  const slider = document.querySelector("#recently-viewed-slider");
  console.log("RV: init slider attempt. items =", items.length, "slider =", slider);

  if (!slider) return;

  // If not enough items, don't init slider (but you can still show the list)
  if (items.length < 5) {
    console.warn("RV: Not enough items for slider — skipping init.");
    return;
  }

  // Wait until the custom element has its init() method (common with AJAX swaps)
  let tries = 0;
  const maxTries = 30; // 30 * 50ms = 1.5s max

  const tryInit = () => {
    tries++;

    // slider might have been replaced during rendering—re-query
    const s = document.querySelector("#recently-viewed-slider");
    if (!s) return;

    if (typeof s.init !== "function") {
      if (tries < maxTries) return setTimeout(tryInit, 50);
      console.warn("RV: slider.init never became available.");
      return;
    }

    // ✅ Safe to run slider
    s.dataset.infinite = "true";
    s.init();

    // ✅ Now show buttons
    const btnWrapper = s.querySelector(".slider-buttons");
    if (btnWrapper) btnWrapper.style.display = "";

    console.log("RV: slider initialized.");
  };

  tryInit();
}


 initRecentlySlider(items);

}

/* ---- CALL ON DOM READY ---- */
document.addEventListener("DOMContentLoaded", renderRecentlyViewed);



/* ----------------------------------------------------
   RECENTLY VIEWED ON COMBINED
------------------------------------------------------ */

(function () {
  // ---- call helper (safe) ----
  function callRecentlyViewed(reason) {
    console.log("RV: trigger ->", reason);

    const fn = window.renderRecentlyViewed || (typeof renderRecentlyViewed === "function" ? renderRecentlyViewed : null);
    if (typeof fn !== "function") {
      console.warn("RV: renderRecentlyViewed() not found on window.");
      return;
    }

    // Let Shopify finish swapping DOM
    setTimeout(() => fn(), 50);
  }

  // ---- 1) Catch real select changes (and custom events that target variant-selects) ----
  function onVariantUIChange(e) {
    // Case A: target is the select itself
    let select = e.target?.matches?.('select[name^="options["]')
      ? e.target
      : e.target?.closest?.('variant-selects')?.querySelector?.('select[name^="options["]');

    // Case B: target is something inside variant-selects (your original approach)
    if (!select) {
      select = e.target?.closest?.('variant-selects select[name^="options["]') || null;
    }

    if (!select) return;

    const opt = select.options[select.selectedIndex];
    console.log("RV: option changed", {
      label: select.name,
      value: select.value,
      productUrl: opt?.dataset?.productUrl || null,
    });

    callRecentlyViewed("variant ui change");
  }

  // Use CAPTURE so we still catch it if theme JS is aggressive
  document.addEventListener("change", onVariantUIChange, true);
  document.addEventListener("input", onVariantUIChange, true);

  // ---- 2) Catch combined-listing navigation clicks (often data-product-url links) ----
  document.addEventListener(
    "click",
    (e) => {
      const el = e.target.closest("[data-product-url]");
      if (!el) return;
      // don’t prevent navigation; just rerender after swap
      callRecentlyViewed("data-product-url click");
    },
    true
  );

  // ---- 3) Catch URL changes (AJAX navigation via pushState/replaceState) ----
  let lastUrl = location.href;

  function checkUrlChange(reason) {
    if (location.href === lastUrl) return;
    lastUrl = location.href;
    callRecentlyViewed("url change (" + reason + ")");
  }

  const _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    checkUrlChange("pushState");
  };

  const _replaceState = history.replaceState;
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    checkUrlChange("replaceState");
  };

  window.addEventListener("popstate", () => checkUrlChange("popstate"));

  // ---- 4) Shopify section swaps ----
  document.addEventListener("shopify:section:load", () => callRecentlyViewed("shopify:section:load"));

  // ---- initial run ----
  document.addEventListener("DOMContentLoaded", () => callRecentlyViewed("DOMContentLoaded"));
})();











/* ----------------------------------------------------
   AUTO-INIT RH SLIDERS (except recently viewed)
------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("rh-slider").forEach(slider => {

    // Skip Recently Viewed by ID
    if (slider.id === "recently-viewed-slider") return;

    slider.init?.();
  });
});


/* ----------------------------------------------------
   UPSSELL (You May Also Like) RECOMMENDATIONS SLIDER
------------------------------------------------------ */
function initUpsellSlider() {
  const slider = document.getElementById("pdp-related-products-slider");
  if (!slider) return;

  if (slider._initialized) return;

  const track = slider.querySelector(".slider-track");
  const slides = track?.querySelectorAll(".slide") || [];

  if (!track || slides.length === 0) return;

  console.log("INIT UPSSELL SLIDER 🚀", slides.length, "slides");

  slider.init?.();
  slider._initialized = true;
}

document.addEventListener("DOMContentLoaded", initUpsellSlider);

new MutationObserver(() => {
  initUpsellSlider();
}).observe(document.body, { childList: true, subtree: true });


/* ----------------------------------------------------
   Complementary Products SLIDER
------------------------------------------------------ */
function initComplementarySlider() {
  const slider = document.getElementById("pdp-complementary-products-slider");
  if (!slider) return;

  if (slider._initialized) return;

  const track = slider.querySelector(".slider-track");
  const slides = track?.querySelectorAll(".slide") || [];

  if (!track || slides.length === 0) return;

  console.log("complementary UPSSELL SLIDER 🚀", slides.length, "slides");

  slider.init?.();
  slider._initialized = true;
}

document.addEventListener("DOMContentLoaded", initComplementarySlider);

new MutationObserver(() => {
  initComplementarySlider();
}).observe(document.body, { childList: true, subtree: true });







/* ----------------------------------------------------
   SLIDESHOW
------------------------------------------------------ */

class RHSlideshow extends HTMLElement {
  constructor() {
    super();

    this.slides = Array.from(this.querySelectorAll(".rh-slide"));
    this.current = 0;

    this.interval = parseInt(this.dataset.interval || 5000, 10);
    this.autoplay = this.dataset.autoplay === "true";

    if (this.slides.length <= 1) return;

    this.setup();
    this.startAuto();

  }

  setup() {
    this.slides.forEach((slide, i) => {
      slide.style.opacity = i === 0 ? "1" : "0";
      slide.style.zIndex = i === 0 ? "2" : "1";
      slide.style.transition = "opacity 1s ease";
    });
  }

  startAuto() {
    if (!this.autoplay) return;
    this.stopAuto();
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stopAuto() {
    clearInterval(this.timer);
  }

  next() {
    const prev = this.current;
    this.current = (this.current + 1) % this.slides.length;

    this.fade(prev, this.current);
  }

  fade(prevIndex, nextIndex) {
    const prev = this.slides[prevIndex];
    const next = this.slides[nextIndex];

    prev.style.opacity = "0";
    next.style.opacity = "1";

    prev.style.zIndex = "1";
    next.style.zIndex = "2";
  }
}

customElements.define("rh-slideshow", RHSlideshow);




/* Verticl slider

document.addEventListener("DOMContentLoaded", function () {
  const verticalSlider = document.querySelector(".vertical-slider");
  if (!verticalSlider) return;

  const list = verticalSlider.querySelector("ul");
  const slides = verticalSlider.querySelectorAll(".slider__slide");

  slides.forEach(slide => {
    slide.querySelector("button").addEventListener("click", () => {
      const slideTop = slide.offsetTop;
      const slideBottom = slideTop + slide.offsetHeight;
      const viewTop = list.scrollTop;
      const viewBottom = viewTop + list.clientHeight;

      // If active slide is NOT fully visible → scroll it into view
      if (slideTop < viewTop || slideBottom > viewBottom) {
        list.scrollTo({
          top: slideTop - 20,
          behavior: "smooth"
        });
      }
    });
  });
});

*/


/* ===========================
   Vertical slider scroll fix
   Works on regular + Combined Listings
   =========================== */
/*
function initVerticalSliderScroll() {
  const verticalSlider = document.querySelector(".vertical-slider");
  if (!verticalSlider) return;

  // element that actually scrolls
  const list =
    verticalSlider.querySelector("ul") ||
    verticalSlider.querySelector(".vertical-slider__list") ||
    verticalSlider;

  const slides = verticalSlider.querySelectorAll(".slider__slide");

  slides.forEach((slide) => {
    const btn = slide.querySelector("button");
    if (!btn) return;

    // prevent double-binding
    if (btn.dataset.vsBound === "1") return;
    btn.dataset.vsBound = "1";

    btn.addEventListener("click", () => {
      const slideTop = slide.offsetTop - list.offsetTop;
      const slideBottom = slideTop + slide.offsetHeight;

      const viewTop = list.scrollTop;
      const viewBottom = viewTop + list.clientHeight;

      if (slideTop < viewTop || slideBottom > viewBottom) {
        list.scrollTo({
          top: Math.max(0, slideTop - 20),
          behavior: "smooth",
        });
      }
    });
  });
}

function setupVerticalSliderScrollWatchers() {
  // bind only once
  if (window.__vs_watchers_bound) return;
  window.__vs_watchers_bound = true;

  // Initial
  document.addEventListener("DOMContentLoaded", () => {
    initVerticalSliderScroll();
  });

  // 1) MutationObserver: catches Combined Listings DOM swaps
  const target =
    document.querySelector("main") ||
    document.querySelector("#MainContent") ||
    document.body;

  const mo = new MutationObserver(() => {
    // debounce a bit so Shopify finishes replacing markup
    clearTimeout(window.__vs_mo_t);
    window.__vs_mo_t = setTimeout(() => {
      initVerticalSliderScroll();
    }, 50);
  });

  mo.observe(target, { childList: true, subtree: true });

  // 2) Also hook History API (some combined setups change URL this way)
  const _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    setTimeout(initVerticalSliderScroll, 50);
  };

  const _replaceState = history.replaceState;
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    setTimeout(initVerticalSliderScroll, 50);
  };

  window.addEventListener("popstate", () => {
    setTimeout(initVerticalSliderScroll, 50);
  });

  // 3) Dawn variant events (harmless if not used)
  document.addEventListener(
    "variantChange",
    () => setTimeout(initVerticalSliderScroll, 50),
    true
  );
  document.addEventListener(
    "variant:change",
    () => setTimeout(initVerticalSliderScroll, 50),
    true
  );
}

// ✅ run once globally
setupVerticalSliderScrollWatchers();

*/


/* ===========================
   Vertical slider scroll fix
   - Click scrolls clicked item into view
   - ALSO auto-scrolls when li.rh-active changes
   Works on regular + Combined Listings
   =========================== */

function scrollChildIntoView(list, child, pad) {
  if (!list || !child) return;
  pad = typeof pad === "number" ? pad : 20;

  const listRect = list.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();

  const childTop = childRect.top - listRect.top + list.scrollTop;
  const childBottom = childTop + childRect.height;

  const viewTop = list.scrollTop;
  const viewBottom = viewTop + list.clientHeight;

  if (childTop < viewTop || childBottom > viewBottom) {
    list.scrollTo({
      top: Math.max(0, childTop - pad),
      behavior: "smooth",
    });
  }
}

function scrollActiveThumbIntoView() {
  const ul = document.getElementById("rh-product-slider-thumb");
  if (!ul) return;

  const active = ul.querySelector("li.rh-active");
  if (!active) return;

  scrollChildIntoView(ul, active, 20);
}

function initVerticalSliderScroll() {
  const sliders = document.querySelectorAll(".vertical-slider");
  if (!sliders.length) return;

  sliders.forEach((verticalSlider) => {
    // element that actually scrolls
    const list =
      verticalSlider.querySelector("ul") ||
      verticalSlider.querySelector(".vertical-slider__list") ||
      verticalSlider;

    if (!list) return;

    // bind ONCE per list
    if (list.dataset.vsBound === "1") return;
    list.dataset.vsBound = "1";

    // 1) Click -> scroll clicked slide/li into view
    list.addEventListener("click", (e) => {
      const slide = e.target.closest(".slider__slide, li");
      if (!slide || !list.contains(slide)) return;
      scrollChildIntoView(list, slide, 20);
    });

    // 2) Auto-scroll when active class changes (rh-active on thumb lis)
    // Only needed for the thumb UL, but harmless elsewhere
    if (list.id === "rh-product-slider-thumb") {
      // initial
      scrollActiveThumbIntoView();

      // watch class changes / DOM swaps
      const mo = new MutationObserver(() => {
        clearTimeout(list.__vsActiveT);
        list.__vsActiveT = setTimeout(() => {
          scrollActiveThumbIntoView();
        }, 30);
      });

      mo.observe(list, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  });
}

function setupVerticalSliderScrollWatchers() {
  // bind only once
  if (window.__vs_watchers_bound) return;
  window.__vs_watchers_bound = true;

  document.addEventListener("DOMContentLoaded", () => {
    initVerticalSliderScroll();
  });

  const target =
    document.querySelector("main") ||
    document.querySelector("#MainContent") ||
    document.body;

  const mo = new MutationObserver(() => {
    clearTimeout(window.__vs_mo_t);
    window.__vs_mo_t = setTimeout(() => {
      initVerticalSliderScroll();
      scrollActiveThumbIntoView(); // in case markup swapped and active exists
    }, 50);
  });

  mo.observe(target, { childList: true, subtree: true });

  const _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    setTimeout(() => {
      initVerticalSliderScroll();
      scrollActiveThumbIntoView();
    }, 50);
  };

  const _replaceState = history.replaceState;
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    setTimeout(() => {
      initVerticalSliderScroll();
      scrollActiveThumbIntoView();
    }, 50);
  };

  window.addEventListener("popstate", () => {
    setTimeout(() => {
      initVerticalSliderScroll();
      scrollActiveThumbIntoView();
    }, 50);
  });

  document.addEventListener("variantChange", () => {
    setTimeout(() => {
      initVerticalSliderScroll();
      scrollActiveThumbIntoView();
    }, 50);
  }, true);

  document.addEventListener("variant:change", () => {
    setTimeout(() => {
      initVerticalSliderScroll();
      scrollActiveThumbIntoView();
    }, 50);
  }, true);
}

// ✅ run once globally
setupVerticalSliderScrollWatchers();





/* =========================
   RH Swatch Hover Preview (stable after variant re-render)
   - Hover preview only triggers after real mouse movement
   - Reverts to checked value on leave
   - If NOTHING is checked for that option group -> shows "Make selection"
   ========================= */

document.addEventListener("DOMContentLoaded", () => {
  const MAKE_SELECTION_TEXT = "Make selection";

  // Track last real mouse movement time (prevents "fake hover" after DOM replacement)
  let lastMouseMoveAt = 0;

  document.addEventListener(
    "pointermove",
    (e) => {
      if (e.pointerType === "mouse") lastMouseMoveAt = Date.now();
    },
    true
  );

  function getTargetSpan(optionName) {
    if (!optionName) return null;
    const legend = document.getElementById(`rh-${optionName}`); // e.g. rh-Fabric
    if (!legend) return null;
    return legend.querySelector("span[data-selected-value]") || legend.querySelector("span");
  }

  function setSpan(optionName, text) {
    const span = getTargetSpan(optionName);
    if (!span) return;
    span.textContent = text ?? "";
  }

  function getFieldset(el) {
    return el.closest?.(".rh-swatches-pd");
  }

  function getInputForLabel(labelEl, fieldset) {
    const forId = labelEl.getAttribute("for");
    if (!forId) return null;

    // Prefer within same fieldset, fallback to document
    return (
      fieldset?.querySelector?.(`#${CSS.escape(forId)}`) ||
      document.getElementById(forId) ||
      null
    );
  }

  // ✅ Key change: return "Make selection" if nothing is checked
  function getCheckedValue(optionName, fieldset) {
    if (!fieldset || !optionName) return MAKE_SELECTION_TEXT;

    const checked = fieldset.querySelector(
      `input[data-option-name="${CSS.escape(optionName)}"]:checked`
    );

    if (checked) return checked.value || "";
    return MAKE_SELECTION_TEXT;
  }

  function restore(optionName, fieldset) {
    setSpan(optionName, getCheckedValue(optionName, fieldset));
  }

  // Hover preview (ONLY if the mouse moved recently)
  document.addEventListener(
    "pointerover",
    (e) => {
      const label = e.target.closest?.("label[data-option-name]");
      if (!label) return;

      const fieldset = getFieldset(label);
      if (!fieldset) return;

      // Ignore hover events caused by DOM replacement (no real mouse move)
      if (Date.now() - lastMouseMoveAt > 120) return;

      const optionName = label.dataset.optionName;
      const input = getInputForLabel(label, fieldset);
      if (!optionName || !input) return;

      setSpan(optionName, input.value || "");
    },
    true
  );

  // Restore on leave (also only after real mouse move)
  document.addEventListener(
    "pointerout",
    (e) => {
      const label = e.target.closest?.("label[data-option-name]");
      if (!label) return;

      const fieldset = getFieldset(label);
      if (!fieldset) return;

      if (Date.now() - lastMouseMoveAt > 120) return;

      const optionName = label.dataset.optionName;
      if (!optionName) return;

      restore(optionName, fieldset);
    },
    true
  );

  // Keep span synced when a selection changes
  document.addEventListener("change", (e) => {
    const input = e.target?.closest?.("input[data-option-name]");
    if (!input) return;

    const fieldset = getFieldset(input);
    if (!fieldset) return;

    restore(input.dataset.optionName, fieldset);

    // After a click Shopify may re-render under the cursor.
    // Reset move time so immediate post-render pointerover doesn't override checked text.
    lastMouseMoveAt = 0;
  });

  // Initial sync for all fieldsets
  document.querySelectorAll(".rh-swatches-pd").forEach((fieldset) => {
    const optionNames = new Set(
      Array.from(fieldset.querySelectorAll("input[data-option-name]"))
        .map((i) => i.dataset.optionName)
        .filter(Boolean)
    );
    optionNames.forEach((name) => restore(name, fieldset));
  });
});



//Active Fileters


(() => {
  function getAllMounts() {
    return Array.from(document.querySelectorAll("[data-rh-active-facets-mount]"));
  }
  

  function findSourceForSection(sectionId) {
    // Source is inside facets snippet where section.id exists
    return document.querySelector(`[data-rh-active-facets-source="${CSS.escape(sectionId)}"]`);
  }

  function syncOne(sectionId) {
    const mount = document.getElementById(`RH-ActiveFacetsMount-${sectionId}`);
    const source = findSourceForSection(sectionId);

    if (!mount) return;

    if (!source) {
      mount.innerHTML = "";
      mount.hidden = true;
      return;
    }

    // If there are no active pills, source may be empty or hidden by logic
    const html = source.innerHTML.trim();
    if (!html) {
      mount.innerHTML = "";
      mount.hidden = true;
      return;
    }

    mount.hidden = false;
    mount.innerHTML = html;

    // Click delegation: forward to the REAL source link so Dawn AJAX runs
    mount.onclick = (e) => {
      const a = e.target.closest("a[href]");
      if (!a) return;

      const href = a.getAttribute("href");
      if (!href) return;

      // Prevent normal navigation (we want AJAX)
      e.preventDefault();

      const currentSource = findSourceForSection(sectionId);
      if (!currentSource) {
        window.location.href = href;
        return;
      }

      // Find the matching anchor in the real active facets UI
      const match = currentSource.querySelector(`a[href="${CSS.escape(href)}"]`);

      if (match) {
        // Trigger Dawn's AJAX handler by clicking the real link
        match.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
      } else {
        // Fallback: do normal navigation
        window.location.href = href;
      }
    };
  }

  function initObservers() {
    // For every mount, observe the source area and re-sync on AJAX DOM replacements
    getAllMounts().forEach((mount) => {
      const sectionId = mount.getAttribute("data-rh-active-facets-mount");
      if (!sectionId) return;

      // Initial sync
      syncOne(sectionId);

      // Watch for the source being replaced/updated by Dawn AJAX
      const observer = new MutationObserver(() => {
        syncOne(sectionId);
      });

      // Observe the closest container that changes during AJAX updates
      // (This is more reliable than observing just the source node, which may be replaced.)
      const watchRoot =
        document.getElementById("FacetFiltersForm") ||
        document.querySelector("facet-filters-form") ||
        document.querySelector(".facets-container") ||
        document.body;

      observer.observe(watchRoot, { childList: true, subtree: true });
    });
  }

  function boot() {
    initObservers();
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Theme editor / section reloads
  document.addEventListener("shopify:section:load", boot);
})();

